












































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EventCardListItemFooterComponent extends Vue {
  @Prop({ required: true })
  changeQuantity: boolean;

  decrease() {
    this.$emit('on-decrease');
  }

  increase() {
    this.$emit('on-increase');
  }

  select() {
    this.$emit('on-select');
  }
}
